import { Field } from '..';

import {
  FormFieldsType,
  ValidationType
} from '../../../../types/FieldModelTypes';

abstract class FormField extends Field {
  readonly field: string;
  readonly label: string;
  isRelevant!: boolean;
  relevantCondition: string | undefined;
  helperText: string | undefined;
  isHidden: boolean;
  validationType: string | undefined;
  regexType: string | undefined;
  validationMessage: string | undefined;
  validations: ValidationType[] | undefined;
  placeholder: string | undefined;
  labelHelperText: string | undefined;
  shouldShowLabel: boolean | undefined;
  shouldIncludeInCreateOrder: boolean;
  shouldCheckAdditionalRelevantCondition: boolean | undefined;
  isExpectedRemoval: boolean | undefined;
  isMarginBottomZero: boolean | undefined;
  supportingField: string | undefined;
  shouldShowErrorIcon: boolean | undefined;
  isRequired: boolean | undefined;
  defaultValue: string | boolean | undefined;
  hideRadioButtons: boolean | undefined;
  isCustomizedRadioOptions: boolean | undefined;
  customYupValidation: string | undefined;
  category: string | undefined;
  isTnc: boolean | undefined;

  constructor(formFieldData: FormFieldsType) {
    super();
    const {
      should_include_in_create_order = true,
      field,
      label,
      relevantCondition,
      helper_text,
      isHidden,
      validation_type,
      regex_type,
      validation_message,
      validations,
      placeholder,
      labelHelperText,
      shouldShowLabel,
      shouldCheckAdditionalRelevantCondition,
      supporting_field,
      isMarginBottomZero,
      should_show_error_icon,
      name,
      placeholder_text,
      is_required,
      custom_yup_validation,
      default_value,
      hide_radio_buttons,
      is_customized_radio_options,
      category,
      is_tnc
    } = formFieldData;

    this.field = field ?? name;

    this.label = label ?? '';
    this.relevantCondition = relevantCondition;
    this.helperText = helper_text;
    this.isHidden = isHidden ? true : false;
    this.validationType = validation_type;
    this.regexType = regex_type;
    this.validationMessage = validation_message;
    this.validations = validations;
    this.placeholder = placeholder ?? placeholder_text;
    this.labelHelperText = labelHelperText;
    this.shouldShowLabel = shouldShowLabel;
    this.shouldIncludeInCreateOrder = should_include_in_create_order;
    this.shouldCheckAdditionalRelevantCondition =
      shouldCheckAdditionalRelevantCondition;
    this.isExpectedRemoval = true;
    this.isMarginBottomZero = isMarginBottomZero ?? true;
    this.shouldShowErrorIcon = should_show_error_icon;
    this.supportingField = supporting_field;
    if (relevantCondition) {
      this.isRelevant = true;
    }
    this.isRequired = is_required;
    this.customYupValidation = custom_yup_validation;
    this.defaultValue = default_value;
    this.hideRadioButtons = hide_radio_buttons;
    this.isCustomizedRadioOptions = is_customized_radio_options;
    this.category = category;
    this.isTnc = is_tnc;
  }
}

export default FormField;
